import { GameCoverWithUploadedFileInput } from '@crazygames/graph-types/submission/game-covers-uploaded-file-input.type';
import { UploadedFileInput } from '@crazygames/graph-types/util/uploaded-file-input.type';
import { UploadedFile } from '../domain/upload';
import { GAME_COVERS_RESOLUTIONS, GameCoversWithUploadedFile, GameCoverWithUploadedFile } from './games/game';

export function uploadedFileToInput(file: UploadedFile): UploadedFileInput {
  return {
    path: file.path,
    uploadId: file.uploadId,
    size: file.size,
  };
}

export function convertArrayGameCoversToInput(gameCovers: GameCoverWithUploadedFile[]) {
  return gameCovers.map((gc) => ({
    ...gc,
    uploadedFile: gc.uploadedFile ? uploadedFileToInput(gc.uploadedFile) : null,
    __typename: undefined,
  }));
}

export function convertGameCoversToInput(gameCovers: GameCoversWithUploadedFile) {
  const output: GameCoverWithUploadedFileInput[] = [];
  for (const coverId in gameCovers) {
    const file = gameCovers[coverId as GAME_COVERS_RESOLUTIONS];
    if (file) {
      output.push({
        size: coverId as GAME_COVERS_RESOLUTIONS,
        uploadedFile: uploadedFileToInput(file),
      });
    }
  }
  return output;
}
